<template>
  <div class="category" v-if="categoriesName.length>0">
    <ul class="main_category_list flx" v-bind:style="{ marginLeft : paddingLeftValue + 'px' }">
      <li class="heading">{{$t('category')}}</li>
      <li
        class="active"
        v-for="(category,index) in categoriesName"
        :key="index"
        @click="goToGetProductByCategory(category.id)"
      >{{category.name}}</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import constant from "../../utils/constant";
import { bus } from "../../main";
import ImageSpinner from "../Common/ImageSpinner";

export default {
  name: "Category",
  components: {
    ImageSpinner
  },
  props: {
    categoriesName: {
      type: Array
    }
  },
  data() {
    return {
      width: "",
      paddingLeftValue: ""
    };
  },
  methods: {
    goToGetProductByCategory(categoryId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/product-by-category?type=NORMAL&categoryid=" + categoryId);
    },
    goToCategoryListing(categoryId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/category-listing");
    }
  },
  updated() {
    this.$nextTick(function() {});
    if (this.categoriesName.length > 0) {
      let element = document.getElementsByClassName("heading");
      this.paddingLeftValue = element[0].offsetWidth * 1.25;
    }
  }
};
</script>